import { render, staticRenderFns } from "./download-app.vue?vue&type=template&id=5c1f59d9&"
import script from "./download-app.vue?vue&type=script&lang=js&"
export * from "./download-app.vue?vue&type=script&lang=js&"
import style0 from "./download-app.vue?vue&type=style&index=0&id=5c1f59d9&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports